<!-- filepath: src/components/shared/FormsSignedCell.vue -->
<template>
  <span>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          v-bind="attrs"
          v-on="on"
          small
          :color="formsSigned ? 'primary' : 'grey'"
          :style="{
            cursor: formsSigned ? 'pointer' : 'not-allowed',
            opacity: formsSigned ? 1 : 0.4,
          }"
          @click="formsSigned && showDialog(formsSigned)"
        >
          picture_as_pdf
        </v-icon>
      </template>
      <span>
        {{ formsSigned ? "View signed forms" : "No signed forms available" }}
      </span>
    </v-tooltip>
    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <v-card-title>
          Signed Forms
          <v-spacer />
          <v-btn icon @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <FormsSignedViewer :value="selectedFormsSigned" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import FormsSignedViewer from "@/components/views/club/FormsSignedViewer.vue";
export default {
  name: "FormsSignedCell",
  components: { FormsSignedViewer },
  props: {
    formsSigned: { type: [Array, Object, String], default: null }
  },
  data() {
    return {
      dialog: false,
      selectedFormsSigned: null
    };
  },
  methods: {
    showDialog(formsSigned) {
      this.selectedFormsSigned = formsSigned;
      this.dialog = true;
    }
  }
};
</script>